import withConfigTransport from '../../services/config-transport/withConfigTransport'
import VaDateInputComponent from '../va-date-input/VaDateInput.vue'

export const VaDateInput = withConfigTransport(VaDateInputComponent)
